import { Component, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { AppsettingsConfig } from 'src/app/modules/client-config/models/client-config';
import { DntCaptchaComponent } from '../../capture/dnt-captcha/dnt-captcha.component';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { TranslocoService } from '@ngneat/transloco';
import { PasswordRecoveryService } from '../../../services/password-recovery.service';
import { SharedService } from 'src/app/core/services/shared.service';
import { NotificationComponent } from 'src/app/modules/shared/components/notification/notification.component';

/**
 * Страница "Восстановление пароля",
 * - пользователь вводит свою почту и капчу, если почта существует, создается токен, отправляется письмо пользователю с токеном, действует 24 часа(статус УЗ не меняем)
 * - после перехода по ссылке из письма(сравнивается токены, и что не прошло 24 часа), пользователь попадает на страницу, что удачно подтверждена почта и кнопка "продолжить" (в будущем тут будет еще выпадашка как продолжать: телефон/контрольный вопрос)
 * - нажал продолжить, открылось окно подтверждения телефона. В течении 300 секунд пользователь должен позвонить (раз в 5 секунд отправляем запрос на проверку, позвонил ли пользователь)
 * - пришел удачный ответ(тут возможно стоит создать одноразовый токен и ограничить время ввода нового пароля, скажем 300 секундами). Кидаем на страницу, что успешно телефон подтвержден и поля ввода нового пароля
 * - на бэке проверяем токен, что не использован и не просрочен, и если пароли совпали, то меняем пароль, помечаем токен как использованный, и статус УЗ не меняем
 * */
@Component({
  selector: 'app-password-recovery',
  templateUrl: './password-recovery.component.html',
  styleUrls: ['./password-recovery.component.scss'],
})
export class PasswordRecoveryComponent {
  @ViewChild('notification') notification!: NotificationComponent;
  @ViewChild('appDntCaptcha') appDntCaptcha: DntCaptchaComponent;

  form!: UntypedFormGroup;
  captchaApiUrl = '/account/createcaptcha';
  errorMessage = '';

  constructor(
    private sharedService: SharedService,
    appsettings: AppsettingsConfig,
    httpClient: HttpClient,
    private translocoService: TranslocoService,
    private passwordRecoveryService: PasswordRecoveryService,
    private router: Router
  ) {
    this.initPasswordRecoveryComponent();

    this.captchaApiUrl = appsettings.backendUrl + this.captchaApiUrl;

    this.appDntCaptcha = new DntCaptchaComponent(httpClient, translocoService);
  }

  initPasswordRecoveryComponent(): void {
    this.form = this.passwordRecoveryService.strangerform;
  }

  onSend() {
    if (this.form.invalid || !this.appDntCaptcha.correctSum) {
      this.form.markAllAsTouched();
      return;
    }

    const rawVal = this.form.getRawValue();

    const formData = new FormData();
    formData.append('DNTCaptchaText', this.appDntCaptcha.text);
    formData.append('DNTCaptchaToken', this.appDntCaptcha.token);
    formData.append('DNTCaptchaInputText', this.appDntCaptcha.inputText);
    formData.append('login', rawVal.email);
    formData.append('isStranger', 'true');

    this.passwordRecoveryService.passwordChangeInit(formData).subscribe(
      (res) => {
        if (res?.error == 'incorrect_sum') {
          this.appDntCaptcha.correctSum = false;
        } else {
          this.router.navigate(['/password-recovery-info']);
        }
      },
      (err: HttpErrorResponse) => {
        this.appDntCaptcha.doRefresh(); // You can not send the same captcha twice.
        console.log('error: ', err);
        this.errorMessage =
          err.status === 429 ? this.translocoService.translate('errorCodes.RATELIMITER') : this.sharedService.buildErrors(err.error);
      }
    );
  }
}
